module.exports = __webpack_public_path__ + "static/media/fm.49813904.svg";